// extracted by mini-css-extract-plugin
export default {"options-column":"style_options-column__vsPTr__oBlIk","options-btn":"style_options-btn__U3uoy__oBlIk","tooltip":"style_tooltip__vJlkv__oBlIk"};